/** Access-request flow steps: the step value controls which sub-panel renders (the success state is an overlaying dialog, not a step) */
export var PortalAccessStepEnum;
/** Searchable sub-broker legal entity */

(function (PortalAccessStepEnum) {
  PortalAccessStepEnum["EntitySearch"] = "entitySearch";
  PortalAccessStepEnum["MemberDetails"] = "memberDetails";
  PortalAccessStepEnum["SubBrokerRegister"] = "subBrokerRegister";
})(PortalAccessStepEnum || (PortalAccessStepEnum = {}));